import api from './api'
import utils from './utils'

var app = {
  api,
  utils,
};

export default app;